// extracted by mini-css-extract-plugin
export default {"title":"Nav_title__YR22y","active":"Nav_active__6Oiwp","connectWalletBtn":"Nav_connectWalletBtn__DH22v","connect":"Nav_connect__Hou2Y","account":"Nav_account__56POS"};